import { CalendarIcon } from "Assets/icons";
import { dateFormat, getAge, userFullName } from "helpers/common";
import { Col, Container, Row } from "react-bootstrap";
import GuardianDetailRow from "./GuardianDetailRow";
import moment from "moment";

const ClientDetails = ({ data, showAssessmentDate = true }) => {

  const clientType = data?.client_detail?.client_type;
  const therapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;

  return (
    <>
      <Row className="border-bottom p-2">
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Last Name
            </h6>
            <p className="m-0 themeBlue">
              {data?.lastname}
            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              First Name
            </h6>
            <p className="m-0 themeBlue">
              {data?.firstname}
            </p>
          </div>
        </Col>
      </Row>
      <Row className="border-bottom p-2">
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Date of Birth:
            </h6>
            <p className="m-0 themeBlue">
              <span className="icn me-2">
                <CalendarIcon />
              </span>
              {dateFormat(data?.client_detail?.dob)}
            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Age:
            </h6>
            <p className="m-0 themeBlue">
              {getAge(data?.client_detail?.dob)}
            </p>
          </div>
        </Col>
      </Row>
      <Row className="border-bottom p-2">
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Report Date:
            </h6>
            <p className="m-0 themeBlue">
              <span className="icn me-2">
                <CalendarIcon />
              </span>
              {dateFormat(moment())}
            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Clinician Name:
            </h6>
            <p className="m-0 themeBlue text-capitalize">{userFullName(therapist)}</p>
          </div>
        </Col>
      </Row>
      <Row className="border-bottom p-2">
        {clientType == "school" && <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              School Name:
            </h6>
            <p className="m-0 themeBlue">
              {data?.client_detail?.client_school_detail?.client_school?.name}
            </p>
          </div>
        </Col>}
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              City/Town:
            </h6>
            <p className="m-0 themeBlue">
              {data?.client_detail?.city_town}
            </p>
          </div>
        </Col>
      </Row>

      {/* Guardian Details */}
      {data?.client_detail?.client_guardian_mapping?.length > 0 &&
        data?.client_detail?.client_guardian_mapping?.map(
          (guardian, index) => {
            const slug = guardian?.client_guardian?.client_role?.slug;
            if (slug !== (clientType == "school" ? "teacher" : "parent")) {
              return null;
            }

            return (
              <GuardianDetailRow
                index={index}
                guardian={guardian}
                slug={slug}
              />
            );
          }
      )}

      {showAssessmentDate && (
        <Row className="border-bottom p-2">
          <Col md="6" className="py-2">
            <div className="d-flex align-items-start gap-10 flex-wrap">
              <h6
                className="m-0 fw-sbold themeBlue"
                style={{
                  minWidth: 200,
                  fontSize: 14,
                }}
              >
                Assessment Dates:
              </h6>
              <p className="m-0 themeBlue">
                <span className="icn me-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                  >
                    <path
                      d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z"
                      fill="#071E3E"
                    />
                  </svg>
                </span>
                16/07/2024, 18/07/2024
              </p>
            </div>
          </Col>
        </Row>
      )}
    </>
  )
}


export default ClientDetails;